export const PageHero = ({ eyebrow, title, intro, image }) => (
  <section className="relative overflow-hidden bg-emerald-950">
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />}
    <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/90 to-emerald-950/40" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-300">{eyebrow}</p>
      <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white max-w-3xl">{title}</h1>
      <p className="mt-5 text-sm sm:text-base text-emerald-50/85 max-w-2xl leading-relaxed">{intro}</p>
    </div>
  </section>
);
